import React, { Component } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import Home from './pages/Home';
import MyInfoCallback from './pages/MyInfoCallback';
import GlobalStyle from './components/ui/GlobalStyle';
import ThemeProvider from './components/utilities/ThemeProvider';
import Consent from './pages/Consent';

class App extends Component {
    // Initialize base url
    basename = process.env.REACT_APP_API_ENDPOINT;

    componentWillMount() {
        axios.defaults.baseURL = this.basename;
    }

    render() {
        return (
            <ThemeProvider>
                <GlobalStyle />
                <BrowserRouter basename={process.env.REACT_APP_BASE_NAME}>
                    <Switch>
                        <Route path="/home/:id" exact component={Home} />
                        <Route path="/" exact component={Home} />
                        <Route path="/callback" exact component={MyInfoCallback} />
                        <Route path="/consents/*" exact component={Consent} />
                        <Route path="/:id" exact component={Home} />
                        <Route path="/:id/:stage" exact component={Home} />
                    </Switch>
                </BrowserRouter>
            </ThemeProvider>
        );
    }
}
export default App;
